(() => {
  if (window.chiqCategoryMotionBound) return;
  window.chiqCategoryMotionBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-motion-toggle]');
    if (!button) return;
    const story = button.closest('[data-story-motion]');
    if (!story) return;
    const paused = story.dataset.motionPaused !== 'true';
    story.dataset.motionPaused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    const label = paused ? 'Resume animation' : 'Pause animation';
    button.textContent = label;
    button.setAttribute('aria-label', label + ': ' + story.querySelector('h2').textContent.trim());
  });
})();
